export enum ToolOwnershipEnum {	
	BPL = 0,
	Customer = 10,
	ThirdParty = 20
}